@if (show) {
  <div>
    @if (serviceGroup?.title) {
      <h3
      class="pt-4 pl-4 text-lg font-bold md:text-2xl">{{ serviceGroup.title | translate }}</h3>
    }
    @if (serviceGroup?.subtitle) {
      <h4
      class="pl-4 mb-4 text-sm font-light md:text-lg">{{ serviceGroup.subtitle | translate }}</h4>
    }
  </div>
}
